import {getPlayerBonusConfig} from '../../configs/playerBonus';

/**
 * Конкретные числа экономического бонуса игрока.
 *
 * У «явных» ботов рейтинговых матчей они ЗАФИКСИРОВАНЫ в состоянии на старте
 * матча (player.bonusConfig) и оттуда же попадают в запись реплея и в историю.
 * Иначе правка конфига переписывала бы прошлое: реплей пересчитывает состояние
 * заново, и старая запись разошлась бы с тем, что происходило в живом матче.
 *
 * Запасной вариант — текущий конфиг по уровню бонуса: так работают локальные
 * игры (там уровень выбирает человек перед стартом) и старые записи, сделанные
 * до появления зафиксированных чисел.
 */
export const getPlayerBonusValues = (player) => (
  (player && player.bonusConfig) || getPlayerBonusConfig(player && player.bonus)
);
